export default __webpack_public_path__ + "static/media/kidney_banner1.f3ce5c7e.jpg";